export const BatchIssues = {
  BATCH_SIZE: 20,
  LARGE_BATCH_SIZE: 50,
};
